import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtField.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "event-info font-size-h2-normal"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("593"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.ordertype_tmpl_name || '-') + " ")])]), _vm.template.serviceNameView === 1 && _vm.orderInfo.serviceId ? _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("69"))]), _c('div', {
    staticClass: "field-line-value",
    staticStyle: {
      "word-break": "normal",
      "flex": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.service_name + ' - ' + _vm.orderInfo.service_num + (_vm.orderInfo.unit === null ? '' : _vm.orderInfo.unit) || '-') + " ")])]) : _vm._e(), _vm.otherService ? _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("594"))]), _c('div', {
    staticClass: "field-line-value",
    staticStyle: {
      "word-break": "normal",
      "white-space": "pre-line"
    }
  }, [_vm._v(" " + _vm._s(_vm.otherService) + " ")])]) : _vm._e(), [1, 2, 3, 5, 6, 7, 8, 10].indexOf(_vm.user.sysrole) != -1 && _vm.template.priorityView === 1 ? _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("595"))]), _c('div', {
    staticClass: "field-line-value",
    staticStyle: {
      "word-break": "normal"
    }
  }, [_vm._v(" " + _vm._s({
    1: i18n.tc("88"),
    2: i18n.tc("89"),
    3: i18n.tc("90")
  }[_vm.orderInfo.priority] || '-') + " ")])]) : _vm._e(), _vm.template.imgView === 1 ? _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("410"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._l(_vm.remarkPicList, function (item, index) {
    return _c('img', {
      key: index,
      staticClass: "previewer-demo-img img",
      attrs: {
        "src": item.img_url
      },
      on: {
        "click": function ($event) {
          return _vm.show(index);
        }
      }
    });
  }), _vm.remarkPicList.length === 0 ? _c('span', [_vm._v("-")]) : _vm._e()], 2)]) : _vm._e(), _vm.template.descriView === 1 ? _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("160"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.detail_desc || '-') + " ")])]) : _vm._e(), _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("596"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.take_order_person || '-') + " ")]), _vm.orderInfo.fk_t_take_order_user_id ? _c('div', {
    staticClass: "customer-icon",
    on: {
      "click": _vm.goPersonInfo
    }
  }, [_c('img', {
    attrs: {
      "src": "spa_static_mobile/icon/custom24_26@3x.png"
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "customer-icon",
    on: {
      "click": function ($event) {
        return _vm.tel(_vm.orderInfo.take_order_person_mobile);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "spa_static_mobile/icon/tel24_24@3x.png"
    }
  })])]), _c('div', {
    staticClass: "field-line"
  }, [_c('div', {
    staticClass: "field-line-label"
  }, [_vm._v(i18n.tc("259"))]), _c('div', {
    staticClass: "field-line-value"
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.take_order_time || '-') + " ")])])]), _c(__unplugin_components_0, {
    attrs: {
      "size": "h2",
      "extFields": _vm.orderExtFields
    }
  }), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('Previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.remarkPicListForPreviewer,
      "options": _vm.options
    }
  })], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };